import { action, computed, makeObservable, observable } from "mobx";
import { CountId } from "./dropDown";
import { NnwClient } from "./nnwClient";
import { PeselUtility } from "./peselUtility";
import Validator from "./validator";

export interface NnwProposalModel {
    clients: NnwClient[];
    numberOfSeniors: number;
    nnwClientsDuplicate: boolean;

    setNnwNumberOfClients: (nnwNumberOfClients: CountId) => void;
    reset: () => void;
}

interface NnwProposaArguments {
    clients?: NnwClient[];
}

export class NnwProposal implements NnwProposalModel {
    @observable clients = [] as NnwClient[];

    constructor(args?: NnwProposaArguments) {
        makeObservable(this);

        this.clients = args?.clients ?? [];
    }

    @action
    public reset() {
        this.clients = [];
    }

    @action
    public setNnwNumberOfClients(nnwNumberOfClients: CountId) {
        const countOfNnwClients = this.clients.length;
        const diff = Number(nnwNumberOfClients) - countOfNnwClients;

        if (diff > 0) {
            for (let i = 0; i < diff; i++) {
                this.clients.push(new NnwClient());
            }
        } else if (diff < 0) {
            for (let i = 0; i < Math.abs(diff); i++) {
                this.clients.pop();
            }
        }
    }

    @computed
    public get nnwClientsDuplicate() {
        const pesels = this.clients.filter(x => x.pesel.value !== "").map(x => x.pesel.value);

        return (new Set(pesels).size !== pesels.length);
    }

    @computed
    public get numberOfSeniors() {
        let seniors = 0;
        this.clients.forEach((client) => {
            const pesel = client.pesel.value;

            if (Validator.pesel(pesel) && (PeselUtility.isAgeOver60FromPesel(pesel))) {
                seniors++;
            }
        });

        return seniors;
    }
}
